var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "app"
    }
  }, [_c("transition", {
    attrs: {
      name: _vm.transitionName
    }
  }, [_c("keep-alive", {
    attrs: {
      include: _vm.include
    }
  }, [_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e()], 1)], 1), _c("transition", {
    attrs: {
      name: _vm.transitionName
    }
  }, [!_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };